import axios from "../../../utils/authAxios";
const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/SecurityConfiguration";

export const getCameraType2List = async () => {
  return axios.get(`${api_base_url}/GetCameraType2`).then((res) => {
    return res;
  });
};

export const addCameraType2 = async (newCameraType2) => {
  const { data } = await axios.post(
    `${api_base_url}/AddCameraType2`,
    newCameraType2
  );
  return data;
};

export const deleteCameraType2 = async (ids) => {
  const { data } = await axios.delete(`${api_base_url}/DeactivateCameraType2`, {
    data: ids,
  });
  return data;
};

export const updateCameraType2 = async (editCameraType2) => {
  const { data } = await axios.put(
    `${api_base_url}/EditCameraType2`,
    editCameraType2
  );
  return data;
};
